import React, {Component} from 'react';
import {withTranslation} from 'react-i18next';
import moment from 'moment';
import 'moment/locale/es-mx';
import { Grid, Col, ControlLabel, AutoComplete, Button, Panel, Dropdown, Icon, DatePicker, IntlProvider } from 'rsuite';
import esES from 'rsuite/lib/IntlProvider/locales/es_ES';
import enUS from 'rsuite/lib/IntlProvider/locales/en_US';
import dateFnsFormat from 'date-fns/format';
import dateFnsEsLocale from 'date-fns/locale/es';

import Layout from '../../components/Layout';
import TableList from '../../components/TableList';
import Swal from 'sweetalert2';
import $ from 'jquery';
import ModalMap from './ModalMap';


class Entries extends Component{
    constructor(props){
        super(props);

        this.handleChange = this.handleChange.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
        this.search = this.search.bind(this);
        this.updateColumns = this.updateColumns.bind(this);
        this.getLocation = this.getLocation.bind(this);
        this.search = this.search.bind(this);

        this.state = {
            start_date:moment().startOf('month').format('YYYY-MM-DD'),
            end_date:moment().format('YYYY-MM-DD'),
            employee:this.props.t('screen.reports.all'),
            employees:[],
            location:"",
            locations:[],
            data:[],
            filename:'name',
            // groupClass separa visualmente los 3 bloques de la tabla
            // (Empleado / Entrada / Salida) — sin esto se leen como una sola
            // franja continua de 7 columnas en vez de 3 grupos de datos.
            columns:[
                {title:'employee', name:'employee', visible:true, width:'20%', groupClass:'col-group-employee col-divider-right'},
                {title:'date', name:'date', visible:true, width:'15%', groupClass:'col-group-entry'},
                {title:'face', name:'face', visible:true, width:'5%', groupClass:'col-group-entry'},
                {title:'location', name:'location', visible:true, width:'20%', groupClass:'col-group-entry col-divider-right'},
                {title:'date', name:'date', visible:true, width:'15%', groupClass:'col-group-exit'},
                {title:'face', name:'face', visible:true, width:'5%', groupClass:'col-group-exit'},
                {title:'location', name:'location', visible:true, width:'20%', groupClass:'col-group-exit'}
            ],
            list:[],
            userType:'',
        }
    }

    async componentDidMount(){
        // Sin esto el DatePicker (y cualquier otro texto formateado con
        // moment) muestra nombres de mes en inglés aunque el resto de la
        // app esté en español — moment usa su propio locale global,
        // independiente del locale de i18next/IntlProvider. Mismo locale
        // ("es-mx") que ya registra Calendar.js para mantener consistencia
        // si el usuario visita ambas pantallas en la misma sesión.
        moment.locale(this.props.i18n.language && this.props.i18n.language.startsWith('en') ? 'en' : 'es-mx');

        var accountId  = atob(sessionStorage.getItem(btoa('account_id')));
        accountId = accountId.substring(1, accountId.length - 1);

        var req = {
            api:'accounts',
            url:'employees/by-account/'+accountId,
            method:'GET',
            requireToken:true
        }
        var employees = await this.props.fetchRequest(req);
        var data = [this.props.t('screen.reports.all')];
        if(employees !== undefined){
            employees.map((e)=>(
                data.push(e.firstName+' '+e.lastName+' '+(e.maternalSurname === null ? '' : e.maternalSurname))
            ));

            // this.state.employee se inicializó en el constructor con
            // this.props.t('screen.reports.all') — si en ese momento
            // i18next todavía no había resuelto el idioma real (aquí
            // arranca en 'en-US', que no existe, y cae a 'es' un instante
            // después), ese valor queda congelado en el idioma equivocado
            // ("All" en vez de "Todos") y ya nunca vuelve a calzar con la
            // traducción actual — search() nunca entra al primer branch
            // ("Todos" === "Todos") y termina buscando un empleado
            // inexistente por nombre, tronando en .id de un índice -1.
            // Para este punto las traducciones ya están listas, así que se
            // vuelve a fijar aquí con el valor fresco.
            this.setState({employees: employees, data: data, employee: data[0]});
        }
        //console.log(employees)
        
        var locations = await this.props.fetchRequest({
            api:'accounts',
            method:'get',
            url:'locations/by-account/'+accountId,
            obj:null,
            requireToken:true
        });

        if(locations !== undefined){
            this.setState({locations: locations});
        }
        //console.log(locations)
        let user = sessionStorage.getItem('userType');
        //console.log(user)
        if (user === 'client') {
            //console.log(sessionStorage.getItem('locationId'))
            locations.map((l,i) => {
                if (l.id === sessionStorage.getItem('locationId')) {
                    //console.log(l)
                    //console.log('match')
                    this.setState({
                        location: l.name,
                        userType:'client'
                    });
                }
            })
            
        }else {
            this.setState({
                location: 'all'
            });
        }

        // search() ya se encarga de (re)inicializar la tabla (resetTable()+
        // setTable()) con los resultados reales — llamar setTable() aquí
        // primero solo para reinicializarla otra vez segundos después, sin
        // darle tiempo a la extensión fixedColumns de terminar su propio
        // setup diferido, es lo que producía un "Failed to execute
        // 'removeChild'" al destruir/remontar una instancia a medio armar.
        await this.search();
    }

    componentDidUpdate(){
        var data = this.state.data;
        if(data.length > 0){
            if(data[0] !== this.props.t('screen.reports.all')){
                data[0] = this.props.t('screen.reports.all');

                this.setState({data: data, employee: data[0]});
            }            
        }        
    }

    handleChange(e){
        console.log(e.target.value)
        this.setState({[e.target.name]: e.target.value});
    }

    // El DatePicker de rsuite entrega un objeto Date (o null si se limpia),
    // no un string como el <input type="date"> nativo que reemplaza — el
    // resto del componente (search(), el estado) sigue esperando 'YYYY-MM-DD'.
    handleDateChange(name, date){
        if(date){
            this.setState({[name]: moment(date).format('YYYY-MM-DD')});
        }
    }

    async search(){
        $('.rs-btn-default').blur();
        var id = '';
        var error = "";

        var accountId  = atob(sessionStorage.getItem(btoa('account_id')));
        accountId = accountId.substring(1, accountId.length - 1);
        
        if(this.state.employee === this.props.t('screen.reports.all')){
            id = 'all';
        }else if(this.state.employee === ""){
            error = this.props.t('error_alert.no_employee');
        }else{
            var index = this.state.employees.findIndex(obj => 
                obj.firstName+' '+obj.lastName+' '+obj.maternalSurname === this.state.employee
            );

            id = this.state.employees[index].id;
        }

        var obj = {
            startDate: this.state.start_date,
            endDate: this.state.end_date,
            employeeId: id,
            locationName: this.state.location
        };

        var req = {
            api: 'reports',
            url: 'reports/time-check-in-by-account/'+accountId,
            obj: obj,
            method: 'POST',
            modal: this.props.modal_loader,
            message_modal: this.props.t('modal.spin.searching'),
            requireToken: true
        };

        if(error === ""){
            var request = await this.props.fetchRequest(req);
            var list = [];
            
            if(request === undefined){
                request = [];
            }
            
            request.map((r, i) =>{
                var obj = [r.employee.name];

                var entry = r.checks.findIndex(item =>
                    item.checkType === 'in'
                );

                var out = r.checks.findIndex(item =>
                    item.checkType === 'out'
                );
                //'icon/'+col.location+'/#7E7E7E/no_location/one/'+col.latitude+'/'+col.longitude
                //let noLoc = r.checks[entry].metersFromLocation.toFixed(0)+' mts. de '+r.checks[entry].location;
                //console.log(noLoc)
                obj.push(
                    entry !== -1 ? moment(r.checks[entry].timeFormatted).format('DD/MM/YYYY HH:mm') : "",
                    entry !== -1 ? r.checks[entry].validFace ? 
                        'icon/check/green/entry/no_action'
                    : 'icon/close/red/entry/no_action' : "",
                    entry !== -1 ? 
                        r.checks[entry].metersFromLocation !== null ? 
                            r.checks[entry].location !== "" ?
                               'icon/'+ r.checks[entry].metersFromLocation.toFixed(0)+' mts. de '+r.checks[entry].location +'/#7E7E7E/no_location/one/'+r.checks[entry].latitude+'/'+r.checks[entry].longitude
                            : 'icon/map-marker/'+(r.checks[entry].latitude !== null && r.checks[entry].longitude !== null ? 
                                'green/entry/one/' : '#7E7E7E/no_location/no_action/')+
                                r.checks[entry].latitude+'/'+r.checks[entry].longitude
                            
                        : ""
                    : "",
                    out !== -1 ? moment(r.checks[out].timeFormatted).format('DD/MM/YYYY HH:mm') : "",
                    out !== -1 ? r.checks[out].validFace ? 
                        'icon/check/green/out/no_action'
                    : 'icon/close/red/out/no_action' : "",
                    out !== -1 ? 
                        r.checks[out].metersFromLocation !== null ? 
                            r.checks[out].location !== "" ?
                               'icon/'+ r.checks[out].metersFromLocation.toFixed(0)+' mts. de '+r.checks[out].location +'/#7E7E7E/no_location/one/'+r.checks[out].latitude+'/'+r.checks[out].longitude
                            : 'icon/map-marker/'+(r.checks[out].latitude !== null && r.checks[out].longitude !== null ? 
                                'green/out/one/' : '#7E7E7E/no_location/no_action/')+
                                r.checks[out].latitude+'/'+r.checks[out].longitude
                        : ""
                    : ""
                )

                return list.push(obj)
            });

            // resetTable()/setTable() corren en el callback de setState,
            // después de que React ya volvió a renderizar el <tbody> con
            // "list" — si no, DataTables puede escanear un render intermedio
            // (mismo bug ya corregido en Locations.js/Home.js). Antes esto
            // se cubría con dos setTimeout (500ms/1000ms) que además
            // reabrían el modal de carga a la mitad (parpadeo cerrado→
            // abierto→cerrado) y agregaban ~1s de espera artificial — ya no
            // hace falta con el estado dtReady de TableList.js, que oculta
            // la tabla cruda sin depender del modal.
            // El setTimeout(…, 0) que queda es distinto: esta tabla usa
            // scrollX + scrollY + fixedColumns juntos, y la extensión
            // fixedColumns termina su propio armado (clonar el header,
            // envolver el scroll) en un callback diferido después del
            // primer pintado. Si resetTable() la destruye ANTES de que ese
            // callback corra, el destroy()/remount por key deja el <table>
            // en un padre distinto al que React tenía registrado y truena
            // con "Failed to execute 'removeChild'" — reproducible con solo
            // buscar dos veces seguidas. Cederle un tick al event loop antes
            // de destruir alcanza para que ese armado diferido termine
            // primero; es imperceptible para el usuario (no es una espera
            // de UX como los setTimeout anteriores).
            this.setState({list: list}, ()=>{
                setTimeout(()=>{
                    this.table.resetTable();
                    this.table.setTable();
                }, 0);
            });
        }else{
            Swal.fire('Error', error, 'error');
        }
            

    }

    updateColumns(e, i){
        var columns = this.state.columns;

        columns[i].visible = e.target.checked;

        this.setState({columns: columns});
    }

    getLocation(e, i, d){
        //console.log('location')
        var list = this.state.list[i];
        //console.log(list)
        //console.log(d)
        var index = list.findIndex(obj => obj.indexOf('map-marker/green/'+d) !== -1 );

        if(index !== -1){
            var name = list[0];
            var lat = parseFloat(list[index].split('/')[5]);
            var lng = parseFloat(list[index].split('/')[6]);

            this.modal_map.handleShow(lat, lng, name)
        }else {
            var name = list[0];
            var lat = parseFloat(list[3].split('/')[5]);
            var lng = parseFloat(list[3].split('/')[6]);

            /*console.log(name)
            console.log(lat)
            console.log(lat)*/
            this.modal_map.handleShow(lat, lng, name)
        }
        
    }

    render(){
        const {t} = this.props;
        // El DatePicker de rsuite trae su propio calendario/textos ("Today",
        // días/meses) en inglés por defecto — IntlProvider lo traduce al
        // idioma actual de la app (i18next), en vez de quedar en inglés
        // suelto dentro de una pantalla en español.
        const isEnglish = this.props.i18n.language && this.props.i18n.language.startsWith('en');
        const rsuiteLocale = isEnglish ? enUS : esES;
        // rsuite formatea las fechas del calendario (mes/día del header) con
        // date-fns internamente, no con moment — el locale de IntlProvider
        // solo traduce los textos fijos (Hoy/Ayer/días de la semana); el mes
        // ("Aug"/"Ago") necesita este formatDate aparte con el locale de
        // date-fns para salir también en español.
        const formatDate = (date, formatStr) => isEnglish ?
            dateFnsFormat(date, formatStr)
            : dateFnsFormat(date, formatStr, {locale: dateFnsEsLocale});
        return (
            <IntlProvider locale={rsuiteLocale} formatDate={formatDate}>
            <Layout {...this.props}>
                <Grid fluid>
                    <Col xs={24}>
                        <h3 className="s-title-page">{t('screen.reports.entries.'+this.state.filename)}</h3>
                    </Col>
                    <Col xs={24}>
                    <Panel className="panel-general" shaded>
                        <Col xs={24} sm={3}>
                            <ControlLabel className="s-table-titles">{t('screen.reports.entries.form.start_date')}</ControlLabel>
                            <DatePicker
                                format="DD/MM/YYYY"
                                value={this.state.start_date ? moment(this.state.start_date).toDate() : null}
                                onChange={(date)=>this.handleDateChange('start_date', date)}
                                cleanable={false}
                                oneTap
                                style={{width:'100%'}}
                                size="sm"
                            />
                        </Col>
                        <Col xs={24} sm={3}>
                            <ControlLabel className="s-table-titles">{t('screen.reports.entries.form.end_date')}</ControlLabel>
                            <DatePicker
                                format="DD/MM/YYYY"
                                value={this.state.end_date ? moment(this.state.end_date).toDate() : null}
                                onChange={(date)=>this.handleDateChange('end_date', date)}
                                cleanable={false}
                                oneTap
                                style={{width:'100%'}}
                                size="sm"
                            />
                        </Col>
                        <Col xs={24} sm={4} className="form-group">
                            <ControlLabel className="s-table-titles">{t('screen.reports.entries.form.location')}</ControlLabel>
                            <select 
                                className="form-control form-control-sm" name="location" 
                                id="location" value={this.state.location}
                                disabled={this.state.userType === 'client'? true : false}
                                onChange={(e)=>this.handleChange(e)}>
                                <option value="all">{t('screen.reports.all')}</option>
                                {this.state.locations.map((loc, i)=>
                                    <option value={loc.name} key={i}>{loc.name}</option>
                                )}
                            </select>
                        </Col>
                        <Col xs={24} sm={4} className="form-group">
                            <ControlLabel className="s-table-titles">{t('screen.reports.entries.form.employee')}</ControlLabel>
                            <AutoComplete
                                data={this.state.data}
                                value={this.state.employee}
                                onChange={(e)=>this.handleChange({target:{name:'employee', value:e}})}
                                id="employee"
                                name='employee'
                                autoComplete="off"
                                required
                                size="sm"
                            />
                        </Col>
                        <Col xs={24} sm={4} style={{marginTop:30}}>
                            <Button className="s-btn-primary" onClick={(e)=>this.search(e)}>
                                {t('button.search')}
                            </Button>
                            <Button onClick={(e)=>this.props.history.goBack()} style={{marginLeft:8}} >
                                {t('button.return')}
                            </Button>
                        </Col>
                        <Col xs={24} sm={6} style={{marginTop:30, textAlign:'right', whiteSpace:'nowrap'}}>
                            <Dropdown title={t('general.table.export')} placement="bottomEnd" className="export-dropdown" style={{display:'inline-block'}}>
                                <Dropdown.Item disabled={this.state.list.length === 0} onClick={()=> this.state.list.length > 0 && this.table && this.table.triggerButton('buttons-excel')}>
                                    Excel
                                </Dropdown.Item>
                                <Dropdown.Item disabled={this.state.list.length === 0} onClick={()=> this.state.list.length > 0 && this.table && this.table.triggerButton('buttons-pdf')}>
                                    PDF
                                </Dropdown.Item>
                            </Dropdown>
                            <Dropdown
                                title={<><Icon icon="columns" /> {t('general.table.columns')}</>}
                                placement="bottomEnd"
                                className="columns-dropdown"
                                style={{marginLeft:8, display:'inline-block'}}
                            >
                                {this.state.columns.map((c, i)=>(
                                    i < this.state.columns.length &&
                                        <Dropdown.Item key={i}>
                                            <label className="col-visibility-item" onClick={(e)=>e.stopPropagation()}>
                                                <input
                                                    type="checkbox"
                                                    checked={c.visible}
                                                    onChange={(e)=>this.updateColumns(e, i)}
                                                /> {t('screen.reports.entries.columns.'+c.name)}
                                            </label>
                                        </Dropdown.Item>
                                ))}
                            </Dropdown>
                        </Col>
                        <Col xs={24}>
                            <TableList
                                {...this.props}
                                onRef={ref => this.table = ref}
                                columns={this.state.columns}
                                btnNew={false}
                                data={this.state.list}
                                actions={[]}
                                actionIcon={this.getLocation}
                                screen={"entries"}
                                searching={false}
                                report={true}
                                table_title={[
                                    {title:'', col:1, groupClass:'col-group-employee col-divider-right'},
                                    {title:'entry', col:3, groupClass:'col-group-entry col-divider-right'},
                                    {title:'out', col:3, groupClass:'col-group-exit'}
                                ]}
                                filename={t('screen.reports.entries.'+this.state.filename)}
                                scroll={true}
                                scrollY="calc(100vh - 340px)"
                                widths={this.state.columns.map(c => c.width)}
                            />
                        </Col>
                    </Panel>
                    </Col>
                </Grid>

                <ModalMap {...this.props} onRef={ref => this.modal_map = ref} />
            </Layout>
            </IntlProvider>
        )
    }
}

export default withTranslation('translations')(Entries);